
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aktuelt/[slug]",
      function () {
        return require("private-next-pages/aktuelt/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aktuelt/[slug]"])
      });
    }
  